//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"BoxColor",1,0],[1,"Clearance",0,"Expression",0],[1,"Objects",0,"ScCollector",0],[1,"OffsetNegativeX",0,"Expression",0],[1,"OffsetNegativeY",0,"Expression",0],[1,"OffsetNegativeZ",0,"Expression",0],[1,"OffsetPositiveX",0,"Expression",0],[1,"OffsetPositiveY",0,"Expression",0],[1,"OffsetPositiveZ",0,"Expression",0],[0,"Type",1,0],[1,"XValue",0,"Expression",0],[1,"YValue",0,"Expression",0],[1,"ZValue",0,"Expression",0]],[[["matrix","position"],"SetBoxMatrixAndPosition",{},2,0],[["featTag"],"ConvertFrecToBuilderData",{},1,0],[["value"],"SetBoxColorValue",{},1,0],[["value"],"SetBoxCsysPosition",{},1,0],[[],"GetBoxCsysPosition",{R_:{position:''}},0,0],[["selections","deselections"],"SetSelectedOccs",{},2,0],[[],"GetBoxFeatTag",{R_:{boxFeatTag:"NXObject"}},0,0]],[]];
SPLM.Tooling.CreateBoxBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.CreateBoxBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.CreateBoxBuilder.BoxType = Object.freeze({
    "General" : "General", "Bounding" : "Bounding"});

export default SPLM;